/**
 * Логотип Autostrada (SVG з головної сторінки autostrada.ua).
 * Виділено з FormWrapper, щоб обгортка залишалась читабельною.
 */
interface AutostradaLogoProps {
    className?: string | undefined
}

export const AutostradaLogo = ({ className }: AutostradaLogoProps) => (
    <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 341.3 66.2"
        xmlSpace="preserve"
        role="img"
        aria-label="Autostrada"
    >
        <path
            d="M25.1 26.4l-4.2-14.3-4.1 14.3h8.3zM27.7 0L42 40H28.9l-1.6-5.3h-13L12.8 40H0L14.3 0h13.4z"
            fill="#fff"
        />
        <path
            d="M55.8 10.9v15.7c0 4 1.4 5.3 4.2 5.3 3.3 0 4.4-2.5 4.4-7v-14H76V40H65.2v-4.3c-2.9 4-5.7 5.1-10.5 5.1-6.3 0-10.4-3.9-10.4-12.2V10.9h11.5z"
            fill="#fff"
        />
        <path
            d="M94.2 1.8v9.1h5.6v6.7h-5.6v10.6c0 2.7.4 3.6 3.6 3.6h1.8V40c-15.3 0-17-.2-17-10.3V17.6h-4.1v-6.7h4.1V1.8h11.6z"
            fill="#fff"
        />
        <path
            d="M113.9 25.2c0 5.5 2.1 7.9 5 7.9 3.1 0 5-2.4 5-7.9 0-4.3-1.9-7.3-4.9-7.3-4-.1-5.1 4-5.1 7.3m4.9-15.1c10.3 0 16.6 6.1 16.6 15.1 0 10.7-7.2 15.7-16.6 15.7-9.3 0-16.6-5.1-16.6-15.1.1-10.1 6.8-15.7 16.6-15.7z"
            fill="#fff"
        />
        <path
            d="M148.8 30.9c0 2.3 1.9 3.6 4.1 3.6 1.8 0 3.7-.6 3.7-2.6 0-4.7-17.8-.9-17.8-12.2 0-7.4 7.7-9.6 13.8-9.6 6.3 0 13.8 1.4 14.4 9.2h-10.5c-.2-1.8-1.6-2.8-3.4-2.8-2 0-3.3.6-3.3 2.1 0 4.1 18.4 1.3 18.4 12.2 0 6.1-5 10.2-15.7 10.2-6.7 0-14-2.1-14.6-9.9h10.9z"
            fill="#fff"
        />
        <path
            d="M185.2 1.8v9.1h5.6v6.7h-5.6v10.6c0 2.7.4 3.6 3.6 3.6h1.8V40c-15.3 0-17-.2-17-10.3V17.6h-4.1v-6.7h4.1V1.8h11.6z"
            fill="#fff"
        />
        <path
            d="M204.8 16.8h.1c1.6-4.6 4.4-6.7 8.9-6.7.5 0 1 .1 1.5.2v11.6c-.8-.1-1.6-.3-2.4-.3-4.7 0-7.1 2.2-7.1 8.5V40h-11.6V10.9h10.5v5.9z"
            fill="#fff"
        />
        <path
            d="M228.5 31.8c0 1.4 1.4 2.4 3.7 2.4 4.1 0 5.1-2.7 5.1-7.2-3.8 1.9-8.8 1.1-8.8 4.8m-10.2-12c0-6.2 4.4-9.8 15.9-9.8 13.8 0 14.6 5.1 14.6 12.1V40h-10.4l-.6-3.1c-3.3 3.1-6.6 3.9-10.9 3.9-5.5 0-10.4-2.7-10.4-8.8 0-13.2 20.7-7.2 20.7-12.7 0-2.1-2.6-2.4-3.8-2.4-1.6 0-3.8.3-4.1 2.8h-11z"
            fill="#fff"
        />
        <path
            d="M273.8 25.6c0-3.2-1.1-6.7-4.9-6.7-3.8 0-4.9 3.7-4.9 6.9 0 3.1.8 6.6 4.6 6.6 3.9 0 5.2-3.4 5.2-6.8m.8 14.4v-3.9c-2.7 3.6-5.2 4.7-8.9 4.7-8.8 0-13.2-6.6-13.2-14.8 0-9.7 5.4-15.9 12.3-15.9 3.7 0 6.2.9 8.7 3.8V0H285v40h-10.4z"
            fill="#fff"
        />
        <path
            d="M300.4 31.8c0 1.4 1.4 2.4 3.7 2.4 4.1 0 5.1-2.7 5.1-7.2-3.8 1.9-8.8 1.1-8.8 4.8m-10.1-12c0-6.2 4.4-9.8 15.9-9.8 13.8 0 14.6 5.1 14.6 12.1V40h-10.4l-.6-3.1c-3.3 3.1-6.6 3.9-10.9 3.9-5.5 0-10.4-2.7-10.4-8.8 0-13.2 20.7-7.2 20.7-12.7 0-2.1-2.6-2.4-3.8-2.4-1.6 0-3.8.3-4.1 2.8h-11z"
            fill="#fff"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M327.7 22.9V9.7L341.3.5v13.2z" fill="#fff" />
        <path fillRule="evenodd" clipRule="evenodd" d="M327.7 40.5V27.3l13.6-9.2v13.2z" fill="#fd4616" />
    </svg>
)
